import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
const ISemanticTokensStylingService = ( createDecorator('semanticTokensStylingService'));
export { ISemanticTokensStylingService };
